<template lang="pug">
  v-row
    v-col(cols="12" sm="12" md="8" lg="6")
      v-slide-y-reverse-transition(mode="out-in")
        v-list
          v-hover(
            v-for="item in courses" :key="item.id "
            v-slot="{ hover }"
          )
            v-list-item.grey.lighten-4.mb-2.transition-all(
              :style="hover ? 'transform: translateY(-2px);' : ''"
              @click.stop.prevent="routeCourse(item)"
            )
              v-list-item-action.mr-4
                tooltip-wrap(
                  :text="$conf.ATTESTATION_STATUSES_TEXT[item.prior_record_status]"
                )
                  v-progress-circular(
                    size="24"
                    value="100"
                    :color="$conf.ATTESTATION_STATUSES_COLORS[item.prior_record_status]"
                  )
              v-list-item-content
                .text-body-1: strong
                  v-badge(
                    :value="item.hasConsultationMessages"
                    color="error"
                    label="Вам что-то ответили"
                    icon="mdi-message"
                    inline left
                  )
                    span {{ item.title }}
                v-list-item-subtitle.ml-2.mt-2 Часов: {{ item.duration }}
              v-list-item-action
                  tooltip-wrap(
                    v-if="item.contract"
                    text="Контракт"
                  )
                    v-btn(
                      @click.stop="routeContract(item)"
                      fab outlined small
                      depressed
                      color="secondary"
                    ): v-icon mdi-file-document
                  v-progress-circular.ml-1.text-center(
                    v-else-if="loading.contract"
                    indeterminate
                    size="38"
                    width="3"
                  )
</template>

<script>
import { mapGetters } from 'vuex';
import SmartTable from '@/components/Global/SmartTable/index.vue';

export default {
  name: 'StudentsCourseList',
  components: {
    SmartTable,
  },
  data: () => ({
    loading: {
      contract: true,
    },
    courses: [],
    headers: [
      { text: 'Контракт', value: 'contract' },
      { text: 'Наименование', value: 'title' },
      { text: 'Объем курса', value: 'duration' },
      { text: 'Статус', value: 'prior_record_status' },
      { text: 'Обучение', value: 'tasks' },
    ],
  }),
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
      isTeacher: 'auth/isTeacher',
    }),

  },
  created() {
    this.loadCourses();
  },
  methods: {
    routeCourse(item) {
      this.$router.push({
        name: 'EducationCourseUnitList',
        params: { courseId: item.id, groupId: item.user_group_id },
      });
    },
    routeContract(item) {
      this.$router.push({
        name: 'ContractView',
        params: { id: item.contract.id },
        query: { courseId: item.id },
      });
    },
    async loadCourses() {
      const { items } = await this.$api.courses.index({
        'search[contracted_or_trained]': true,
        expand: 'user_group_id,course_units,prior_record_status,contract_id,prior_records,priority_user_prior_record',
      });
      this.courses = items;
      this.getMassContracts();
      this.courses.forEach((i) => {
        i.fetchUnread();
      });
    },
    async getMassContracts() {
      const { items } = await this.$api.contracts.getContractsModel({
        expand: 'transactions,qr_code,typical_contract,users,listener_preview_document',
        'search[is_active]': true,
        'search[owner_id]': this.$user.data.id,
      });
      this.courses.forEach((course) => {
        course.contract = items.find(
          ({
            prior_record_id: priorRecordId,
          }) => (course?.priority_user_prior_record?.id === priorRecordId),
        );
      });
      this.loading.contract = false;
    },
  },
};
</script>
<style scoped>
.transition-all {
  transition: all .1s ease-in-out;
}
</style>
